export const environment = {
    production: false,
    appConfigURL: 'assets/config/app-config.json',
  };